/** @module mapsLink */
export default (address) =>
  `https://www.google.com/maps/search/?api=1&query=${address.street}, ${address.street_number}, ${address.neighborhood}, ${address.city}, ${address.state}, ${address.zip}`
